// load scss
import './Main.scss';

import { domReady } from "./Layout";
import "../Fusion/Component/Header";
import { scrollEntrance, scrollEntranceUpdate } from "./ScrollEntrance";

domReady(() => {
    scrollEntrance();
    addEventListener("scroll", scrollEntranceUpdate, false);
    addEventListener("resize", scrollEntranceUpdate, false);
});


// load svg sprite
function LoadSpriteSvgs() {
    // "touch" each sprite SVG file to trigger webpack processing
    function requireAll(r) {
        r.keys().forEach(r);
    }

    requireAll(
        require.context('Packages/Plugins/GesagtGetan.Theme/Resources/Public/Assets/Sprite', true, /\.svg$/)
    );
}
LoadSpriteSvgs();
